import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { delay, finalize, switchMap } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { ModalConfig } from 'src/app/shared/components/modal/modal-config';
import { CHANGE_PASSWORD } from 'src/app/util/constantes-mensajes';
import { HelperFunctions } from 'src/app/util/util-functions';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  standalone: false
})
export class ChangePasswordComponent implements OnInit {
  public modalConfig: ModalConfig;
  // Variable to show/hide spinner
  isLoading = false;
  oldPassword: FormControl;
  constructor(private authService: AuthService, private ngbActiveModal: NgbActiveModal, private ngxUiLoaderService: NgxUiLoaderService) { }

  ngOnInit(): void {
    this.oldPassword = new FormControl(null, Validators.required)
    this.modalConfig = {
      modalTitle: "Cambiar contraseña",
      ...this.modalConfig,
    };
  }

  /**
* A function that checks if the control is invalid
* @param {string} name
* @returns {boolean}
*/
  hasErrors() {
    return HelperFunctions.controlIsInvalid(this.oldPassword);
  }


  /**
* A function that send new password to change it
* @returns {none}
*/
  onSubmit(password: string): void {
    if (this.oldPassword.valid) {
      this.isLoading = true;
      this.ngxUiLoaderService.start('change-password');
      this.authService.login(this.authService.user?.email ?? '', this.oldPassword.value)
        .pipe(
          delay(500),
          finalize(() => { this.isLoading = false; this.ngxUiLoaderService.stop('change-password'); }),
          switchMap(() => this.authService.changePassword(password)))
        .subscribe({
          next: () => this.ngbActiveModal.close({ message: CHANGE_PASSWORD, confirmTitle: "Aceptar" }),
          error: (error) => this.ngbActiveModal.close({ message: error, confirmTitle: "Cerrar", isError: true })
        });
    } else {
      this.oldPassword.markAsTouched();
    }
  }
}
